import { useState } from 'react';
import Box from '@mui/material/Box';
import Header from './Header';
import PropTypes from 'prop-types';
import ChangePasswordModal from '../auth/components/ChangePassword';
import MileMarker from '../mileMarker/components/MileMarker';

const Layout = ({ children }) => {
  const [changePwdOpen, setChangePwdOpen] = useState(false);
  const [mmUploadOpen, setMMUploadOpen] = useState(false);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header setOpenPwdModal={setChangePwdOpen} setOpenMMModal={setMMUploadOpen} />
      <Box component="main" sx={{ flexGrow: 1, padding: 1, borderRadius: 2, height: 'auto' }}>
        {children}
      </Box>
      <ChangePasswordModal open={changePwdOpen} setOpen={setChangePwdOpen} />
      <MileMarker open={mmUploadOpen} setOpen={setMMUploadOpen} />
    </Box>
  );
};

export default Layout;

Layout.propTypes = {
  children: PropTypes.any,
};
